var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMemory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9319 18.3307C7.52356 16.9995 6.90773 16.0066 6.08398 15.3528C4.84856 14.3724 2.88565 14.982 2.16065 13.9703C1.43565 12.9586 2.66856 11.0986 3.10106 10.0011C3.53398 8.90365 1.44273 8.51573 1.6869 8.20406C1.8494 7.99615 2.90648 7.39698 4.85731 6.40573C5.41148 3.2449 7.45856 1.66406 10.9994 1.66406C16.3102 1.66406 18.3336 6.16656 18.3336 9.03073C18.3336 11.8941 15.8836 14.9791 12.3936 15.6445C12.0815 16.0986 12.5315 16.9945 13.7436 18.3307",
    stroke: "#3C5366",
    strokeWidth: 1.94458,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12537 6.04104C7.85287 7.09688 7.9337 7.83855 8.36829 8.26563C8.80245 8.6923 9.54245 8.97188 10.5883 9.10313C10.3508 10.4652 10.6404 11.104 11.4562 11.0198C12.272 10.936 12.7625 10.5969 12.927 10.0031C14.202 10.3615 14.8933 10.0615 15.0004 9.10313C15.1608 7.66563 14.3858 6.51938 14.0679 6.51938C13.7504 6.51938 12.927 6.48063 12.927 6.04104C12.927 5.60146 11.9654 5.35355 11.0975 5.35355C10.2295 5.35355 10.7516 4.76813 9.55995 4.99938C8.76537 5.15354 8.28704 5.50063 8.12537 6.04104V6.04104Z",
    stroke: "#3C5366",
    strokeWidth: 1.66667,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7089 10.625C12.2851 10.8879 11.7039 11.325 11.4589 11.6667C10.8468 12.5208 10.3505 13.0408 10.2422 13.5867",
    stroke: "#3C5366",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemory);
export default __webpack_public_path__ + "static/media/memory.b4fdd6db444523e495ed9dbb16b16222.svg";
export { ForwardRef as ReactComponent };